import Vue from 'vue'
import VueResource from 'vue-resource'
import { config } from '../config'

Vue.use(VueResource);

Vue.http.options.root = config.API_PATH;

class Http {
	/**
	 * HTTP contructor.
	 *
	 * @param {Object} rest
	 *
	 * @return {Void}
	 */
	constructor() {
		this.request = {
			before: null,
			query: {},
			headers: {},
			entity: {},
			includes: []
		};
	}

	buildPath(path, token = true) {
		if (path.charAt(0) == '/') {
			path = path.substr(1);
		}

		if (token) {
			let joiner = '?';

			if (path.match(/(\?.*?\=)/g)) {
				joiner = '&';
			}

			path = `${path}${joiner}token=${sessionStorage.getItem('token')}`;
		}

		return `${Vue.http.options.root}/${path}`;
	}

	before(before) {
		this.request.before = before;

		return this;
	}

	/**
	 * Add request includes.
	 *
	 * @param {Array} includes
	 *
	 * @return {Object}
	 */
	include(includes) {
		this.request.includes = includes;

		return this;
	}

	/**
	 * Add a query object.
	 *
	 * @param {Object} query
	 *
	 * @return {Object}
	 */
	query(query) {
		this.request.query = query;

		return this;
	}

	/**
	 * Add a headers object.
	 *
	 * @param {Object} headers
	 *
	 * @return {Object}
	 */
	headers(headers) {
		this.request.headers = headers;

		return this;
	}

	/**
	 * Add an entity object.
	 *
	 * @param {Object} entity
	 *
	 * @return {Object}
	 */
	entity(entity) {
		this.request.entity = entity;

		return this;
	}

	/**
	 * Send a GET request.
	 *
	 * @param {String} path
	 * @param {Object} query
	 *
	 * @return {Object}
	 */
	get(path, query = {}, cb) {
		return this.execute('get', path, query, {}, {}, cb);
	}

	/**
	 * Send a POST request.
	 *
	 * @param {String} path
	 * @param {Object} entity
	 *
	 * @return {Object}
	 */
	post(path, entity = {}) {
		return this.execute('post', path, {}, entity);
	}

	/**
	 * Send a PUT request.
	 *
	 * @param {String} path
	 * @param {Object} entity
	 *
	 * @return {Object}
	 */
	put(path, entity = {}) {
		return this.execute('put', path, {}, entity);
	}

	/**
	 * Send a DELETE request.
	 *
	 * @param {String} path
	 *
	 * @return {Object}
	 */
	destroy(path) {
		return this.execute('delete', path);
	}

	/**
	 * Execute the request.
	 *
	 * @param {String} method
	 * @param {String} path
	 * @param {Object} query
	 * @param {Object} entity
	 * @param {Object} headers
	 *
	 * @return {Object}
	 */
	execute(method, path, query = {}, entity = {}, headers = {}, cb) {
		if (this.request.headers) {
			headers = $.extend(this.request.headers, headers);

			this.request.headers = {};
		}

		if (this.request.entity) {
			entity = $.extend(this.request.entity, entity);

			this.request.entity = {};
		}

		if (this.request.query) {
			query = $.extend(this.request.query, query);

			this.request.query = {};
		}

		if (this.request.includes.length) {
			query = $.extend(query, { include: this.request.includes.join(',') });

			this.request.includes = [];
		}

		let before = this.request.before;

		this.request.before = null;

		return Vue.http({
			method,
			url: path,
			body: entity,
			params: query,
			headers,
			before
		});
	}
};

export default new Http();



// WEBPACK FOOTER //
// ./src/utils/http.js